import { ValueWithUnit } from '@/types';
import { RawVehicleType, VehicleListingModel } from './schema/inventory/types';
import { Range } from './schema/shared/types';

export const parseRange = (
  rawVehicle: RawVehicleType | VehicleListingModel
): Range => {
  const rangeToUse: ValueWithUnit = {
    value:
      rawVehicle?.RangeAllElectric?.value ??
      rawVehicle?.RangeHybridElectric?.value ??
      0,
    unit:
      rawVehicle?.RangeAllElectric?.unit ??
      rawVehicle?.RangeHybridElectric?.unit ??
      'm',
  };

  const { value, unit } = rangeToUse;

  return {
    value: Number(value),
    unit: unit || 'm',
  };
};
